import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-editor-item',
  templateUrl: './editor-item.component.html',
  styleUrls: ['./editor-item.component.scss']
})
export class EditorItemComponent implements OnInit {
  @Input() itemTitle: string;
  @Input() active = false;

  constructor() {}

  ngOnInit(): void {}
}
